import { ref } from "vue";
import { defineStore } from "pinia";

export const useDsSystemNotifierStore = defineStore(
  "ds-system-toast-notifier",
  () => {
    const maintenanceNotificationId = ref<number>(0);
    const connectivityNotificationId = ref<number>(0);
    const networkNotificationId = ref<number>(0);
    const webSocketNotificationId = ref<number>(0);
    const userChangedNotificationId = ref<number>(0);
    const userLoggedOutNotificationId = ref<number>(0);

    const setMaintenanceId = (id: number): void => {
      maintenanceNotificationId.value = id;
    };

    const setConnectivityId = (id: number): void => {
      connectivityNotificationId.value = id;
    };
    const setNetworkId = (id: number): void => {
      networkNotificationId.value = id;
    };
    const setWebSocketNotificationId = (id: number) => {
      webSocketNotificationId.value = id;
    };
    const setUserChangedId = (id: number): void => {
      userChangedNotificationId.value = id;
    };
    const setUserLoggedOutId = (id: number): void => {
      userLoggedOutNotificationId.value = id;
    };

    return {
      maintenanceNotificationId,
      connectivityNotificationId,
      networkNotificationId,
      webSocketNotificationId,
      userChangedNotificationId,
      userLoggedOutNotificationId,
      setMaintenanceId,
      setConnectivityId,
      setNetworkId,
      setWebSocketNotificationId,
      setUserChangedId,
      setUserLoggedOutId,
    };
  }
);
